(() => {
    "use strict";

    /**
     * StSpinner
     * 
     * How to use it:
     * 
     * Include the <st-spinner></st-spinner> component wherever you want to show a spinner.
     * Then, call stSpinnerService enable and disable functions to show or hide the spinner.
     * 
     * If you want to show the spinner for all the http requests, you have to configure
     * the provider on config and set showAll to true.
     * 
     * Example:
     * 
     * angular.module("app", ["StSpinner"]).config(spiner);
     * 
     * function spinner(spinnerProvider) {
     *      spinnerProvider
     *          .showAll(true);
     * }
     * spinner.$inject = ["stSpinnerProvider"];
     * 
     */

    angular
        .module("stSpinner", [])
        .provider("stSpinner", stSpinner)
        .service("stSpinnerService", stSpinnerService)
        .component("stSpinner", {
            template: `<div class="st-spinner" ng-show="$ctrl.spinner.isLoading()"></div>`,
            controller: stSpinnerController
        })
        .factory("stSpinnerHttpInterceptor", interceptorFactory);

    stSpinner.$inject = ["$httpProvider"];
    function stSpinner($httpProvider) {
        var showAll = false;
        var initialDelay = 100;

        this.showAll = value => {
            if (value === true && !showAll) {
                $httpProvider.interceptors.push("stSpinnerHttpInterceptor");
                showAll = true;
                return this;
            }

            if (value === false && showAll) {
                var ind = $httpProvider.interceptors.indexOf("stSpinnerHttpInterceptor");
                if (ind !== -1) {
                    $httpProvider.interceptors.splice(ind, 1);
                }
                showAll = false;
                return this;
            }

            return this;
        };

        this.initialDelay = value => {
            if (angular.isNumber(value)) {
                initialDelay = value;
                return this;
            }
            return initialDelay;
        };

        this.$get = () => {
            this.initialDelay = () => initialDelay;
            return this;
        };
    }

    stSpinnerService.$inject = ["stSpinner", "$timeout"];
    function stSpinnerService(spinner, $timeout) {
        var loadingCount = 0;

        // can pass in an initial delay to override
        this.enable = initialDelay => {
            // add some delay if this is the first one, to delay turning on spinner if the operation is fast
            if (loadingCount === 0) {
                var delay = parseInt(initialDelay);
                delay = isNaN(delay) ? spinner.initialDelay() : delay;
                $timeout(() => {
                    loadingCount++;
                }, delay);
            } else {
                loadingCount++;
            }
        };

        this.disable = disableDelay => {
            // add some delay if this is the last one left, to delay turning off spinner if another one comes along right away
            if (loadingCount === 1) {
                var delay = parseInt(disableDelay);
                delay = isNaN(delay) ? spinner.initialDelay() : delay;
                $timeout(() => {
                    loadingCount--;
                }, delay);
            } else {
                loadingCount--;
            }
        };

        this.isLoading = () => loadingCount > 0;
    }

    stSpinnerController.$inject = ["stSpinnerService"];
    function stSpinnerController(spinnerService) {
        const ctrl = this;

        ctrl.spinner = spinnerService;
    }

    interceptorFactory.$inject = ["$q", "stSpinnerService"];
    function interceptorFactory($q, spinnerService) {
        return {
            'request': function (configuration) {
                spinnerService.enable();
                return configuration;
            },

            'requestError': function (rejection) {
                spinnerService.disable();
                return $q.reject(rejection);
            },

            'response': function (response) {
                spinnerService.disable();
                return response;
            },

            'responseError': function (rejection) {
                spinnerService.disable();
                return $q.reject(rejection);
            }
        };
    }
})();